import { useState } from "react";
import Swal from "sweetalert2";
import api from "../api/axios";

function AddBuilding() {
  const [name, setName] = useState("");
  const [remarks, setRemarks] = useState("");
  const [remarksDate, setRemarksDate] = useState("");

  const saveService = async (e) => {
    e.preventDefault();

    const errors = [];

    if (!name.trim()) errors.push("Name");
    if (!remarks.trim()) errors.push("ULB Building ID");
    if (!remarksDate) errors.push("ULB Correction Date");

    if (errors.length > 0) {
      Swal.fire({
        icon: "warning",
        //title: "Validation",
        text: `${errors.join(", ")} is required.`,
      });
      return;
    }

    const data = {
      name,
      remarks,
      remarksDate,
    };

    try {
      const response = await api.post("/Building/SaveRemarks", data);

      await Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
      });

      // Clear Form
      setName("");
      setRemarks("");
      setRemarksDate("");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          error.response?.data ||
          "Something went wrong",
      });
    }
  };

  return (
    <div className="card shadow">
      <div className="card-header bg-primary text-white">
        <h5 className="mb-0">Apply For Building</h5>
      </div>

      <div className="card-body">
        <form onSubmit={saveService}>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">Select Zone</label>
             <select name="ddl_Type" id="ddl_Type"  className="form-control">
		<option value="0">--Select Type--</option>
		<option value="1" selected>City</option>

	</select>
            </div>

                <div className="col-md-4 mb-3">
              <label className="form-label">Select Type</label>
              <select name="ddl_Type" id="ddl_Type"  className="form-control">
		<option value="0">--Select Type--</option>
		<option value="1">Old</option>
		<option value="2">New</option>

	</select>
            </div>
           
            <div className="col-md-4 mb-3">
              <label className="form-label">Select Type Of Sanction Map</label>
              <select name="ddl_Type" id="ddl_Type"  className="form-control">
		<option value="0">--Select Type--</option>
		<option value="1">Residential</option>
		<option value="2">Commercial</option>

	</select>
            </div>

    <div className="col-md-6 mb-3">
              <label className="form-label">Name</label>
              <input
                type="text"
                className="form-control"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>

                <div className="col-md-6 mb-3">
              <label className="form-label">Mobile No.</label>
              <input
                type="text"
                className="form-control"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>

                <div className="col-md-12 mb-3">
              <label className="form-label">Full Site Address</label>
              <input
                type="text"
                className="form-control"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Total Amount</label>
              <input
                type="text"
                className="form-control"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>

                <div className="col-md-6 mb-3">
              <label className="form-label">Payment Type</label>
              <input
                type="text"
                className="form-control"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>

            <div className="col-md-3 mb-3">
              <label className="form-label">ULB Correction Date</label>
              <input
                type="date"
                className="form-control"
                value={remarksDate}
                onChange={(e) => setRemarksDate(e.target.value)}
              />
            </div>

            <div className="col-md-12 text-center mt-3">
              <button type="submit" className="btn btn-success px-4">
                Save Correction
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddBuilding;
